import compactEmojis from 'emojibase-data/en/compact.json';
import groupsSubgroups from 'emojibase-data/en/messages.json';
import shortcodes from 'emojibase-data/en/shortcodes/emojibase.json';

const vs16RegExp = /\uFE0F/g;
const zeroWidthJoiner = String.fromCharCode(0x200d);
const removeVS16s = rawEmoji => (rawEmoji.indexOf(zeroWidthJoiner) < 0 ? rawEmoji.replace(vs16RegExp, '') : rawEmoji);
const toHexcode = rawEmoji => {
    const points = [];
    let char = 0;
    let previous = 0;
    let i = 0;
    const unicodeSurrogates = removeVS16s(rawEmoji);
    while (i < unicodeSurrogates.length) {
        char = unicodeSurrogates.charCodeAt(i++);
        if (previous) {
            points.push((0x10000 + ((previous - 0xd800) << 10) + (char - 0xdc00)).toString(16));
            previous = 0;
        } else if (char > 0xd800 && char <= 0xdbff) {
            previous = char;
        } else {
            points.push(char.toString(16));
        }
    }
    return points;
}

export const emojiImageSource = rawEmoji => emojiImageSourceHexcode(toHexcode(rawEmoji).join('-'));

export const emojiImageSourceHexcode = hexcode =>
    `/images/emoji/${hexcode?.toLowerCase()}.svg`;

export const emojiDefinitions = compactEmojis
    .filter(emoji => groupsSubgroups.groups[emoji.group])
    .map(emoji => ({
        ...emoji,
        group: groupsSubgroups.groups[emoji.group].message,
        shortcodes: Array.isArray(shortcodes[emoji.hexcode]) ? shortcodes[emoji.hexcode] : [shortcodes[emoji.hexcode]]
    }))
    .sort((a, b) => a.order - b.order);